import PropTypes from 'prop-types'

const EventMap = ({ coachFacility }) => {
  const {
    latitude,
    longitude,
    name: facilityName = '',
    street = '',
    zipCode = '',
    city = '',
    state = '',
  } = coachFacility

  const hasLatLng = (!!latitude && !!longitude) && (latitude !== 0 && longitude !== 0)
  if (!hasLatLng && !zipCode && !street && !city && !state) return null

  const queryParts = []
  if (facilityName) queryParts.push(facilityName.trim())
  if (street) queryParts.push(street.trim())
  if (city) queryParts.push(city.trim())
  if (state) queryParts.push(state.trim())
  if (zipCode) queryParts.push(zipCode.trim())

  const nonEmptyQueryParts = queryParts.filter(part => part)
  const encodedFacilityInfo = encodeURIComponent(nonEmptyQueryParts.join(', '))

  const mapBaseUrl = `https://www.google.com/maps/embed/v1/place?key=${process.env.GOOGLE_APIS_CLIENT_KEY}&q=${encodedFacilityInfo}`
  const mapSrc = hasLatLng ? `${mapBaseUrl}&center=${latitude},${longitude}&zoom=16` : `${mapBaseUrl}`

  return (
    <iframe
      aria-hidden="true"
      aria-label="Facility Location"
      width="100%"
      height="360"
      style={{ marginTop: '1rem', border: 'none' }}
      src={mapSrc}
      title={`${coachFacility.name} Facility Location`}
    />
  )
}

EventMap.propTypes = {
  coachFacility: PropTypes.shape({
    name: PropTypes.string,
    street: PropTypes.string,
    zipCode: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    city: PropTypes.string,
    state: PropTypes.string,
  }),
}

export default EventMap
